/* ---------------------------------------

    -- 要素の表示、非表示を管理

--------------------------------------- */
export default class Contents{
    constructor(manager){

        //dom
        this.$target;
        this.$show=[];
        this.$text=[];

        this.point = [];

        this.status = {
            current : 0,//表示中のセンテンス
            prevCurrent : 0,//表示中のセンテンス
            nextCurrent : 0,//表示中のセンテンス
            flg : false, // 一回チェックしたら次のポイントまでは処理しない
            show : [],
        }

        this.manager = manager;
        this.scInc = 0;
        this.dir = "";

    }
    init(){

        this.$target = document.querySelectorAll(".js__sc");

        for(let i in this.$target){
            if(this.$target[i].nodeType!=1) break; // dom要素以外は処理止める
            this.status.show[i] = false;
            this.$show[i] = [];
            this.$text[i] = [];

            let _showNo = 0;

            let _$t = this.$target[i].querySelectorAll(".js__sc-show");
            for(let j in _$t){
                if(_$t[j].nodeType!=1) break; // dom要素以外は処理止める
                if(_$t[j].getAttribute('class').indexOf('js__sc-show') != -1){
                    this.$show[i][_showNo] = this.$target[i].querySelectorAll(".js__sc-show")[_showNo];
                    _showNo = _showNo + 1;
                }
            }

            let _textNo = 0;

            _$t = this.$target[i].querySelectorAll(".js__sc-text");
            for(let j in _$t){
                if(_$t[j].nodeType!=1) break; // dom要素以外は処理止める
                if(_$t[j].getAttribute('class').indexOf('js__sc-text') != -1){
                    this.$text[i][_textNo] = this.$target[i].querySelectorAll(".js__sc-text")[_textNo];
                    _textNo = _textNo + 1;
                }
            }

        }

        this.manager.effect.show(document.querySelectorAll(".js__sc-show"),"set");
        this.manager.effect.text(document.querySelectorAll(".js__sc-text"),"set");

    }
    update(inc,dir){

        this.scInc = inc;
        this.dir = dir;

        if (this.$target.length <= 0) return;

        for(let i in this.point){
            if(this.point[i].start<this.scInc&&this.dir=="next"){

                if(this.status.show[i]) continue;
                this.status.show[i] = true;
                if(this.$show[i]) this.manager.effect.show(this.$show[i],"show");
                if(this.$text[i]) this.manager.effect.text(this.$text[i],"show");

            }
        }

    }
    resize () {

        this.point = [];

        for(let i in this.$target){
            if(this.$target[i].nodeType!=1) break; // dom要素以外は処理止める

            let _rect =  this.$target[i].getBoundingClientRect();

            this.point[i] = {
                base : _rect.top + this.manager.scroll.nowInc,
                start: Math.max(_rect.top + this.manager.scroll.nowInc - window.innerHeight*0.7,0),
                end: _rect.top + this.manager.scroll.nowInc + this.$target[i].clientHeight,
            }

        }

    }

}
